import React, {useState} from 'react';
import TaggableSelect from "@/components/select/apiSelect";
import {useApiSearchAdminMembers} from "@/api/userAcademy";
import toFaNumber from "@/lib/utils/number";
import {Button} from "antd";
import {useApiPostAdminProductDeliveryStepManual} from "@/api/product";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";


function AddNewUserToProductDeliveryStep({id, topics}) {


    const [members, setMembers] = useState([])

    const {mutate: checkManualUser, isPending} = useApiPostAdminProductDeliveryStepManual()


    function handleCheck()
    {
        checkManualUser({
            'delivery_step_id': id,
            'useracademy_id' : members?.at(0),
            'topics': topics
        },{
            onSuccess: res => {
                ApiHandleSuccessMessage(res)
            },
            onError: err => {
                ApiHandleErrorMessage(err)
            }
        })
    }
    return (
        <>
            <div>افزودن کاربر جدید به لیست تحویل</div>
            <TaggableSelect name={'user-search'}
                            className={'mt-2'}
                            maxCount={1}

                            searchFn={useApiSearchAdminMembers}
                            onChange={setMembers}
                            values={members}
                            render={(item) => {
                                return toFaNumber(item.mobile ?? '-') + ' - ' + item?.firstname + ' - ' + item?.lastname
                            }}></TaggableSelect>

            <div className="flex justify-end">
                <Button type={'primary'} className={'my-2'} onClick={handleCheck} >
                    افزودن به لیست
                </Button>
            </div>

        </>
    );
}

export default AddNewUserToProductDeliveryStep;